import React from "react";
import { MiTHEME } from "@miplatform/theme";
import { mdiClose } from "@mdi/js";
import Chip from "@mui/material/Chip";
import { MiIcon } from "../MiIcon/MiIcon";

/**
 * MiChip component for displaying chips with customizable props.
 * @component
 * @param {object} props - Component props
 * @param {object} [props.style] - Inline styles for the chip
 * @param {string} props.label - Label text for the chip
 * @param {"small"|"medium"} [props.size="medium"] - Size of the chip (small or medium)
 * @param {"default"|"primary"|"secondary"|"error"|"success"} [props.color="default"] - Color of the chip
 * @param {React.ReactNode} [props.avatar] - Avatar icon or image for the chip
 * @param {"filled"|"outlined"} [props.variant="filled"] - Variant of the chip (filled or outlined)
 * @param {function} [props.onClick] - Click event handler for the chip
 * @param {React.ReactNode} [props.deleteIcon] - Icon to display for deleting the chip
 * @param {function} [props.onDelete] - Callback fired when the delete icon is clicked
 * @param {boolean} [props.clickable=false] - Whether the chip is clickable
 * @param {object} [props.sx] - MUI system prop for additional styling
 * @param {string} [props.className] - Additional CSS class for the chip
 * @returns {JSX.Element} Rendered MiChip component
 */
export const MiChip = (props) => {
  const {
    style,
    label,
    size,
    color,
    avatar,
    variant,
    onClick,
    deleteIcon = (
      <MiIcon
        size={0.6}
        color={MiTHEME.palette.bluegrey.dark}
        path={mdiClose}
      />
    ),
    onDelete,
    clickable = false,
  } = props;

  return (
    <Chip
      {...props}
      data-testid="MiChip"
      color={color}
      size={size}
      label={label}
      variant={variant}
      style={style}
      avatar={avatar}
      onClick={onClick}
      deleteIcon={deleteIcon}
      onDelete={onDelete}
      clickable={clickable}
    />
  );
};
